import apiClient from '@/services/api';

const API_URL = '/currencies';

const sanitizeCurrencyData = (currencyData) => {
  const data = { ...currencyData };
  data.decimal_places = data.decimal_places ? parseInt(data.decimal_places) : 2;
  return data;
};

export default {
  async getCurrencies() { const r = await apiClient.get(API_URL); return r.data; },
  async getCurrency(id) { const r = await apiClient.get(`${API_URL}/${id}`); return r.data; },
  async createCurrency(data) { const r = await apiClient.post(API_URL, sanitizeCurrencyData(data)); return r.data; },
  async updateCurrency(id, data) { const r = await apiClient.put(`${API_URL}/${id}`, sanitizeCurrencyData(data)); return r.data; },
  async deleteCurrency(id) { return apiClient.delete(`${API_URL}/${id}`); }
};
